import { graphql } from "gatsby"
import React from "react"
import Img from "gatsby-image"
import SEO from "../components/seo"
import PMPLayout from "../components/index-components/pmp-layout"
import PMPHeader from "../components/index-components/pmp-header"
import "../styles/press-detail.scss"

class PressDetailPage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isMobile: false,
    }
  }

  componentDidMount() {
    document.body.classList.add("press-detail-page")

    const checkMobile = () => {
      this.setState({ isMobile: window.innerWidth <= 768 })
    }

    checkMobile()
    window.addEventListener("resize", checkMobile)
    this._checkMobile = checkMobile
  }

  componentWillUnmount() {
    document.body.classList.remove("press-detail-page")
    if (this._checkMobile) {
      window.removeEventListener("resize", this._checkMobile)
    }
  }

  render() {
    const pressRelease = this.props.data.wordpressWpPressReleases.acf
    const { isMobile } = this.state

    // Usar heroImageDetailMobile no mobile, heroImageDetailDesktop no desktop
    const heroImage =
      isMobile && pressRelease.heroImageDetailMobile
        ? pressRelease.heroImageDetailMobile
        : pressRelease.heroImageDetailDesktop

    const stripHtmlTags = htmlString => {
      if (!htmlString) return htmlString
      return htmlString.replace(/<[^>]*>/g, "")
    }

    const formatTitleWithHyphens = htmlString => {
      if (!htmlString) return htmlString
      return htmlString.replace(
        /(\w+-\w+)/g,
        '<span style="white-space: nowrap;">$1</span>'
      )
    }

    const formatDate = dateStr => {
      if (!dateStr) return "No date available"
      let date
      if (typeof dateStr === "string" && dateStr.includes("/")) {
        const parts = dateStr.split("/")
        if (parts.length === 3) {
          const [day, month, year] = parts
          date = new Date(`${month}/${day}/${year}`)
        } else {
          date = new Date(dateStr)
        }
      } else {
        date = new Date(dateStr)
      }
      if (isNaN(date.getTime())) return "Invalid date"
      return date.toLocaleDateString("en-US", {
        month: "long",
        day: "numeric",
        year: "numeric",
      })
    }

    const quoteBlocks = Array.isArray(pressRelease.quote_blocks)
      ? pressRelease.quote_blocks
      : []

    const hasQuoteBlocks = quoteBlocks.length > 0

    return (
      <PMPLayout showNavigation>
        <SEO
          title={stripHtmlTags(pressRelease.title) + " | Press Release"}
          description={pressRelease.summary}
          image={heroImage?.localFile?.childImageSharp?.fluid?.src}
          pageType="article"
        />

        <PMPHeader />

        <section className="hero has-background-dark hero-press-detail">
          <div className="hero-head container">
            <h1
              className="title is-1 is-size-3-mobile has-text-white mb-4 has-line-height-1 has-text-centered"
              dangerouslySetInnerHTML={{
                __html: formatTitleWithHyphens(pressRelease.title),
              }}
            />
          </div>

          <div className="press-detail-card-container">
            <div className="press-detail-card">
              <div className="press-detail-card-image">
                <Img
                  fluid={heroImage?.localFile?.childImageSharp?.fluid}
                  alt={pressRelease.title}
                  backgroundColor="transparent"
                />
              </div>

              <div className="press-detail-card-content">
                <div className="press-detail-meta is-flex is-justify-content-flex-start has-text-weight-light">
                  {pressRelease.city_state && (
                    <>
                      <span className="press-detail-location has-text-purple">
                        {pressRelease.city_state}
                      </span>
                      <span className="press-detail-separator has-text-purple">
                        -
                      </span>
                    </>
                  )}
                  <span className="press-detail-date has-text-purple">
                    {formatDate(pressRelease.published_date)}
                  </span>
                </div>

                {hasQuoteBlocks
                  ? quoteBlocks.map((block, index) => (
                      <React.Fragment key={`quote-block-${index}`}>
                        {block.text_1 && (
                          <div
                            className="press-detail-text has-text-weight-light"
                            dangerouslySetInnerHTML={{ __html: block.text_1 }}
                          />
                        )}

                        {block.quote && (
                          <div className="press-detail-quote has-text-purple">
                            <p
                              className="quote"
                              aria-hidden="true"
                              style={{
                                fontSize: "120px",
                                lineHeight: 0.75,
                                color: "#0080FF",
                                height: 60,
                                marginLeft: -5,
                              }}
                            >
                              “
                            </p>
                            <p className="press-detail-quote-text has-text-weight-normal">
                              {block.quote}
                            </p>
                          </div>
                        )}

                        {block.text_2 && (
                          <div
                            className="press-detail-text has-text-weight-light"
                            dangerouslySetInnerHTML={{ __html: block.text_2 }}
                          />
                        )}
                      </React.Fragment>
                    ))
                  : null}

                {!hasQuoteBlocks && pressRelease.text_1 && (
                  <div
                    className="press-detail-text has-text-weight-light"
                    dangerouslySetInnerHTML={{ __html: pressRelease.text_1 }}
                  />
                )}

                {!hasQuoteBlocks && pressRelease.quote && (
                  <div className="press-detail-quote has-text-purple">
                    <p
                      className="quote"
                      aria-hidden="true"
                      style={{
                        fontSize: "120px",
                        lineHeight: 0.75,
                        color: "#0080FF",
                        height: 60,
                        marginLeft: -5,
                      }}
                    >
                      “
                    </p>
                    <p className="press-detail-quote-text has-text-weight-normal">
                      {pressRelease.quote}
                    </p>
                  </div>
                )}

                {!hasQuoteBlocks && pressRelease.text_2 && (
                  <div
                    className="press-detail-text has-text-weight-light"
                    dangerouslySetInnerHTML={{ __html: pressRelease.text_2 }}
                  />
                )}

                {pressRelease.about_inpowered && (
                  <div className="press-detail-about has-text-purple">
                    <h3 className="press-detail-about-title has-text-weight-semibold has-text-purple">
                      About inPowered AI
                    </h3>
                    <div
                      className="press-detail-text has-text-weight-light"
                      dangerouslySetInnerHTML={{
                        __html: pressRelease.about_inpowered,
                      }}
                    />
                  </div>
                )}

                {pressRelease.about_2_title && pressRelease.about_2_text && (
                  <div className="press-detail-about has-text-purple">
                    <h3 className="press-detail-about-title has-text-weight-semibold has-text-purple">
                      {pressRelease.about_2_title}
                    </h3>
                    <div
                      className="press-detail-text has-text-weight-light"
                      dangerouslySetInnerHTML={{
                        __html: pressRelease.about_2_text,
                      }}
                    />
                  </div>
                )}

                {pressRelease.about_3_title && pressRelease.about_3_text && (
                  <div className="press-detail-about has-text-purple">
                    <h3 className="press-detail-about-title has-text-weight-semibold has-text-purple">
                      {pressRelease.about_3_title}
                    </h3>
                    <div
                      className="press-detail-text has-text-weight-light"
                      dangerouslySetInnerHTML={{
                        __html: pressRelease.about_3_text,
                      }}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="press-hero-divider"></div>

            <span className="press-releases-grid-contact has-text-centered has-text-weight-light has-text-purple">
              For press inquiries please contact us at{" "}
              <a href="mailto:press@inpowered.ai">press@inpowered.ai</a>
            </span>
          </div>
        </section>
      </PMPLayout>
    )
  }
}

export default PressDetailPage

export const query = graphql`
  query($slug: String) {
    wordpressWpPressReleases(acf: { slug: { eq: $slug } }) {
      acf {
        title
        slug
        published_date
        city_state
        summary
        text_1
        text_2
        about_inpowered
        about_2_title
        about_2_text
        about_3_title
        about_3_text
        quote
        heroImageDetailDesktop {
          localFile {
            childImageSharp {
              fluid(maxWidth: 1200, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
        heroImageDetailMobile {
          localFile {
            childImageSharp {
              fluid(maxWidth: 600, quality: 100) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  }
`
